import { createStructuredSelector } from 'reselect';
import * as selectors from '../App/selector';

export const mapStateToProps = createStructuredSelector({
    customerType: selectors.selectCustomerType,
    publicFactName: selectors.selectPublicFactName,
    disableBooking: selectors.selectDisableBooking,
});

export type State = ReturnType<typeof mapStateToProps>;
